import React, { Component } from 'react';

import onClickOutside from 'react-onclickoutside';
import image from './images/csv-update-help.png';
import styles from './HelpUpdateBatchCsv.scss';
import { withTranslation } from 'react-i18next';

const HelpUpdateBatchCsv = onClickOutside(
  class extends Component {
    handleClickOutside = () => {
      this.props.hide();
    };

    render() {
      return (
        <div className={styles.help}>
          <div className={styles.image}>
            <img src={image} alt="" />
          </div>
          <br />
          {this.props.t('features.Employees.HelpUpdateBatchCsv.employee_data_can_be_downloaded_from_the_employee_list_page')}
        </div>
      );
    }
  }
);

export default withTranslation()(HelpUpdateBatchCsv);
